import axios from 'axios';

export function put(endpoint, body, options = { token: '', traceId: '', headers: {} }) {
    const { token, headers, traceId } = options;

    return new Promise((resolve) => {
        const reqHeaders = {
            authorization: 'Bearer ' + token,
            'x-trace-id': traceId,
            ...headers,
        };
        axios.put(endpoint, body, { headers: reqHeaders })
            .then(resolve)
            .catch(resolve);
    });
}

export default put;
